/**
 *
 *
 */

import config from '@dkrm/config';
import { Platform } from 'react-native';

// fontFamily workaround because react native may not support multiple definition of font fallback
export const fontFamily = Platform.OS === 'web' ? 'Circular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,sans-serif' : 'Circular Std';
const fonts = `
@font-face {
    font-family: dkrm-glyphs;
    src: url(${config.API_URL_MEDIA_CDN}/fonts/dkrm-glyphs-237b332dd60adea1fb06a5d417d4da88.woff);
    src: url(${config.API_URL_MEDIA_CDN}/fonts/dkrm-glyphs-ie8-5b36fb62a65ea2034d7fc0029b2ee864.eot?#) format(eot),
        url(${config.API_URL_MEDIA_CDN}/fonts/dkrm-glyphs-237b332dd60adea1fb06a5d417d4da88.woff) format(woff),
        url(${config.API_URL_MEDIA_CDN}/fonts/dkrm-glyphs-3b58feb48b7234776e5837bdac40a208.ttf) format(truetype),
        url(${config.API_URL_MEDIA_CDN}/fonts/dkrm-glyphs-9ecf5e997ce1c13de9f802434c35c643.svg) format(svg);
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Circular;
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Light.woff);
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Light.otf) format(opentype);
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Light.ttf) format(truetype);
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Circular;
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Book.woff);
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Book.otf) format(opentype);
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Circular;
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Medium.woff);
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Medium.otf) format(opentype);
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Circular;
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Bold.woff);
    src: url(${config.API_URL_MEDIA_CDN}/fonts/CircularStd-Bold.otf) format(opentype);
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}
`; // prettier-ignore

export default fonts;